import { cn } from '@workspace/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'

const loadingSpinnerVariants = cva(
  'inline-block animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]',
  {
    variants: {
      size: {
        sm: 'h-4 w-4 border-2',
        md: 'h-8 w-8 border-2',
        lg: 'h-12 w-12 border-3',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
)

export function LoadingSpinner({
  className,
  size,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof loadingSpinnerVariants>) {
  return (
    <div className={cn(loadingSpinnerVariants({ size }), className)} {...props}>
      <span className="sr-only">Loading...</span>
    </div>
  )
}

export function LoadingScreen({ message, show = true }: { message?: string; show?: boolean }) {
  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 bg-background',
        show ? 'opacity-100' : 'opacity-0 pointer-events-none'
      )}
    >
      <div className="flex flex-col items-center gap-3">
        <LoadingSpinner size="lg" className="text-white" />
        <div className="text-sm text-muted-foreground">{message}</div>
      </div>
    </div>
  )
}

export { loadingSpinnerVariants }
